export const RQ_GET_FIELD_STRUCTURE_API = {
  url: 'report/filed-structure/<%= divisionId %>',
  method: 'GET',
  auth: true,
};
